exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TwmsMaterialStyle_rightContent__1SdiB {\n  /* position: relative; */\n  float: left;\n  z-index: 2;\n  overflow: auto; }\n\n.TwmsMaterialStyle_rightContentMobile__2O4jo {\n  width: 100%;\n  position: relative;\n  float: left;\n  z-index: 2;\n  overflow: auto; }\n\n.TwmsMaterialStyle_rightContentDisplay__3OcPo {\n  background: #fff;\n  padding: 10px 20px 20px 20px; }\n", ""]);

// exports
exports.locals = {
	"rightContent": "TwmsMaterialStyle_rightContent__1SdiB",
	"rightContentMobile": "TwmsMaterialStyle_rightContentMobile__2O4jo",
	"rightContentDisplay": "TwmsMaterialStyle_rightContentDisplay__3OcPo"
};